// extracted by mini-css-extract-plugin
export default {"custom_table":"styles_custom_table__Di+sL"};